import { useEffect, useRef, useState } from "react";
import CancelIcon from "@mui/icons-material/Cancel";
import { useUserDetails } from "../../../context/auth";
import BASEURL from "../../Utils/Baseurl";
import axios from "axios";
import * as XLSX from "xlsx";
import { useLoading } from "../../../context/loading";
import CelebrationIcon from "@mui/icons-material/Celebration";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import AttendancePDF from "./AttendancePDF";
import CheckinCheckoutReport from "./CheckinCheckoutReport/CheckinCheckoutReport";
import MonthlyStatusReport from "./MonthlyStatusReport";
import PaidIcon from "@mui/icons-material/Paid";
import SentimentSatisfiedAltIcon from "@mui/icons-material/SentimentSatisfiedAlt";
function NewAttendance() {
  const {
    totaldays,
    fromdate,
    enddate,
    allyears,
    allmonth,
    shifts,
    branches,
    employeeCategory,
    employeeType,
  } = useUserDetails();

  const [attendanceData, setAttendanceData] = useState([]);
  const { setCirleLoading } = useLoading();
  const [availableLeaveTypes, setAvailableLeaveTypes] = useState([]);

  let year = allyears.value;
  let month = allmonth.value + 1;
  const getAttendanceData = async () => {
    setCirleLoading(true);
    let start_date = fromdate || "";
    let end_date = enddate || "";
    let shift = shifts?.value || "";

    let employee_category = employeeCategory?.label || "";
    let branch = branches?.label || "";
    let employee_type = employeeType?.label || "";
    const query = `
  query ManagerAttendance(
  $teamleader: String
  $month: Int!
  $year: Int!
  $start_date: Date
  $end_date: Date
  $shift: String
  $empid: String
  $branch: String
  $employee_type: String
  $employee_category: String
) { 
  combinedAttendanceSummary(
    month: $month
    year: $year
    teamleader: $teamleader
    startDate: $start_date
    endDate: $end_date
    shift: $shift
    empid: $empid
    branch: $branch
    employeeType: $employee_type
    employeeCategory: $employee_category
  ) {
    empid
    employeeName
    salaryDays
    totalAbsentDays
    meals
    shiftDays
    
    dailyStatus {
      date
      status
      checkIn
      checkOut
      totalHours
      overtime
    }
  }
}
    `;
    try {
      if (month && year) {
        const response = await axios.post(
          BASEURL,
          {
            query,
            variables: {
              month,
              year,
              start_date,
              end_date,
              employee_category,
              shift,
              branch,
              employee_type,
            },
          },
          {
            headers: { "Content-Type": "application/json" },
          }
        );

        const responseData = response?.data?.data?.combinedAttendanceSummary;

        setAttendanceData(responseData);
        setAvailableLeaveTypes(responseData);
        setCirleLoading(false);
      }
    } catch (error) {
      setCirleLoading(false);
      console.error(error);
    }
  };

  useEffect(() => {
    if (fromdate && enddate && month) {
      const fromMonth = new Date(fromdate).getMonth() + 1;
      const toMonth = new Date(enddate).getMonth() + 1;

      if (fromMonth === month && toMonth === month) {
        getAttendanceData();
      }
    }
  }, [
    fromdate,
    enddate,
    month,
    shifts,
    employeeCategory,
    employeeType,
    branches,
  ]);

  const headerStyle = {
    padding: "5px",
    textAlign: "center",
    border: "1px solid #ddd",
    backgroundColor: "#f5f5f5",
    position: "sticky",
    top: 0,
    minWidth: "100px",
    height: "70px",
    color: "#3F51B5d4",
    zIndex: 5,
  };

  const cellStyle = {
    padding: "8px",
    textAlign: "center",
    border: "1px solid #ddd",
    fontSize: "16px",
    borderRadius: "5px",
    backgroundColor: "white",
  };
  const staticcellStyle = {
    padding: "8px",
    textAlign: "center",
    border: "1px solid #ddd",
    fontSize: "12px",
    color: "#3F51B5d4",
    borderRadius: "5px",
    backgroundColor: "white",
  };

  const stickyCol1 = {
    position: "sticky",
    width: "150px",
    minWidth: "150px",
    maxWidth: "150px",
    left: 0,
    backgroundColor: "#f0f0f0",
    zIndex: 4,
  };

  const stickyCol2 = {
    position: "sticky",
    left: 150,
    backgroundColor: "#f0f0f0",
    zIndex: 3,
  };

  const stickyHed1 = {
    position: "sticky",
    left: 0,
    backgroundColor: "#f5f5f5",
    zIndex: 10,
    borderRight: "1px solid #ddd",
  };

  const stickyHed2 = {
    position: "sticky",
    left: 150,
    backgroundColor: "#f5f5f5",
    zIndex: 10,
    borderRight: "1px solid #ddd",
  };

  // Drag state & ref
  const scrollContainerRef = useRef(null);
  const [isDragging, setIsDragging] = useState(false);
  const [startX, setStartX] = useState(0);
  const [scrollLeft, setScrollLeft] = useState(0);

  // Mouse/touch drag handlers
  const startDrag = (e) => {
    e.preventDefault();
    setIsDragging(true);
    const x = e.pageX || e.touches?.[0]?.pageX;
    setStartX(x);
    setScrollLeft(scrollContainerRef.current.scrollLeft);
  };

  const onDrag = (e) => {
    if (!isDragging) return;
    const x = e.pageX || e.touches?.[0]?.pageX;
    const walk = x - startX;
    scrollContainerRef.current.scrollLeft = scrollLeft - walk;
  };

  const endDrag = () => {
    setIsDragging(false);
  };

  // Add mouse and touch event listeners
  useEffect(() => {
    const container = scrollContainerRef.current;
    if (!container) return;

    container.addEventListener("mousedown", startDrag);
    container.addEventListener("mousemove", onDrag);
    container.addEventListener("mouseup", endDrag);
    container.addEventListener("mouseleave", endDrag);

    container.addEventListener("touchstart", startDrag);
    container.addEventListener("touchmove", onDrag);
    container.addEventListener("touchend", endDrag);

    return () => {
      container.removeEventListener("mousedown", startDrag);
      container.removeEventListener("mousemove", onDrag);
      container.removeEventListener("mouseup", endDrag);
      container.removeEventListener("mouseleave", endDrag);

      container.removeEventListener("touchstart", startDrag);
      container.removeEventListener("touchmove", onDrag);
      container.removeEventListener("touchend", endDrag);
    };
  }, [isDragging, startX, scrollLeft]);

  const exportToExcel = () => {
    const header = [
      "Emp ID",
      "Name",
      "Salary Day",
      "Days Absent",
      "Meals",
      "OT hours",
      "Shift",
    ];
    const maxDays = Math.max(
      ...availableLeaveTypes.map((item) => item.dailyStatus.length)
    );
    for (let i = 1; i <= maxDays; i++) {
      header.push(`Day ${i}`);
    }

    const rows = availableLeaveTypes.map((item) => {
      const row = [
        item.empid,
        item.employeeName,
        item.salaryDays,
        item.totalAbsentDays,
        item.meals,
        item.totalOvertimeHours,
        item.shiftDays || 0,
      ];

      item.dailyStatus.forEach((day) => {
        row.push(
          day.status === "Present"
            ? `CheckIn: ${day.checkIn},CheckOut: ${day.checkOut},OT:${day.overtime},Total: ${day.totalHours}`
            : day.status
            ? day?.status
            : ""
        );
      });

      return row;
    });

    const ws = XLSX.utils.aoa_to_sheet([header, ...rows]);

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Attendance");

    XLSX.writeFile(wb, "Attendance_Report.xlsx");
  };

  return (
    <div style={{ padding: "5px 20px" }}>
      <div
        style={{
          background: "",
          display: "flex",
          justifyContent: "flex-end",
          margin: "5px 0",
          gap: 10,
        }}
      >
        <button
          onClick={exportToExcel}
          style={{
            marginBottom: "10px",
            padding: "8px 12px",
            background: "#4caf50",
            color: "#fff",
            border: "none",
            cursor: "pointer",
          }}
        >
          Download Excel
        </button>
        <CheckinCheckoutReport />
        <AttendancePDF />
        <MonthlyStatusReport />
      </div>
      <div
        ref={scrollContainerRef}
        style={{
          overflowX: "auto",
          maxWidth: "100%",
          maxHeight: "calc(100vh - 150px)",
        }}
      >
        <table
          id="table-to-xls"
          style={{ width: "100%", borderCollapse: "collapse" }}
        >
          {/* Table Head */}
          <thead
            style={{
              position: "sticky",
              top: 0,
              zIndex: 10,
            }}
          >
            <tr
              style={{
                borderBottom: "2px solid #ddd",
                color: "black",
                fontSize: "14px",
              }}
            >
              <th style={{ ...headerStyle, ...stickyHed1 }}>Emp ID</th>
              <th style={{ ...headerStyle, ...stickyHed2 }}>Name</th>
              <th style={headerStyle}>Salary Days</th>
              <th style={headerStyle}>Days Absent</th>
              <th style={headerStyle}>Meals</th>
              <th style={headerStyle}>OT hours</th>
              <th style={headerStyle}>Shift</th>

              {[...Array(totaldays).keys()].map((day) => (
                <th key={day} style={headerStyle}>
                  {day + 1}
                </th>
              ))}
            </tr>
          </thead>

          {/* Table Body */}
          <tbody>
            {attendanceData?.map((row) => (
              <tr key={row.id} style={{ borderBottom: "1px solid #ddd" }}>
                <td style={{ ...staticcellStyle, ...stickyCol1 }}>
                  {row?.empid}
                </td>
                <td
                  style={{
                    ...staticcellStyle,
                    ...stickyCol2,
                    textTransform: "capitalize",
                  }}
                >
                  {row?.employeeName}
                </td>
                <td style={cellStyle}>{row?.salaryDays}</td>
                <td style={cellStyle}>{row?.totalAbsentDays}</td>
                <td style={cellStyle}>{row?.meals}</td>
                <td style={cellStyle}>{row?.totalOvertimeHours || 0.0}</td>
                <td style={cellStyle}>{row?.shiftDays || 0}</td>

                {/* Attendance Days */}
                {Array.isArray(row?.dailyStatus) &&
                  row?.dailyStatus.map((item, ind) => (
                    <td
                      key={ind}
                      style={{
                        ...cellStyle,
                        position: "relative",

                        minWidth: "140px",
                        minHeight: "50px",
                        height: "100px",
                        backgroundColor:
                          item.status === "Present"
                            ? "white"
                            : item.status === "Absent"
                            ? "white"
                            : item.status === "Holiday"
                            ? "white"
                            : "white",
                      }}
                    >
                      {item.status === "Present" ? (
                        <div>
                          <span
                            style={{
                              fontSize: "13px",
                              fontWeight: "500",
                              padding: "2px 5px",
                              margin: "5px",
                              borderRadius: "5px",
                              display: "flex",
                              alignItems: "center",
                              position: "absolute",
                              top: "0",
                              right: "0",
                              zIndex: "1",
                            }}
                          >
                            <CheckCircleIcon
                              sx={{ color: "green", marginRight: "5px" }}
                            />

                            {item?.status}
                          </span>
                          <div
                            style={{
                              marginTop: "18px",
                              fontSize: "12px",
                              display: "flex",
                              flexDirection: "column",
                              color: `${item.checkOut ? "#4caf50" : "red"}`,
                            }}
                          >
                            <p>CheckIn: {item?.checkIn}</p>
                            <p>
                              CheckOut:{" "}
                              {item.checkOut ? item?.checkOut : "null"}
                            </p>
                            <p>OT: {item?.overtime}</p>
                            <p>Total: {item?.totalHours}</p>
                          </div>
                        </div>
                      ) : item?.status === "Absent" || item?.status === "" ? (
                        <p
                          style={{
                            fontSize: "13px",
                            fontWeight: "500",
                            padding: "2px 5px",
                            margin: "5px",
                            borderRadius: "5px",
                            display: "flex",
                            alignItems: "center",
                            position: "absolute",
                            top: "0",
                            right: "0",
                            zIndex: "1",
                            // backgroundColor: "rgba(212, 18, 18, 0.36)",
                          }}
                        >
                          <CancelIcon
                            sx={{ color: "red", marginRight: "5px" }}
                          />
                          {item?.status}
                        </p>
                      ) : item.status.includes("Holiday") ? (
                        <div>
                          <span
                            style={{
                              fontSize: "13px",
                              fontWeight: "500",
                              padding: "2px 5px",
                              margin: "5px",
                              borderRadius: "5px",
                              display: "flex",
                              alignItems: "center",
                              position: "absolute",
                              top: "0",
                              right: "0",
                              zIndex: "1",
                              color: "#934790",
                            }}
                          >
                            <CelebrationIcon
                              sx={{ color: "#934790", marginRight: "5px" }}
                            />
                            {item?.status}
                          </span>
                        </div>
                      ) : item?.status === "Weekoff" ? (
                        <div>
                          <span
                            style={{
                              fontSize: "13px",
                              fontWeight: "500",
                              padding: "2px 5px",
                              margin: "5px",
                              borderRadius: "5px",
                              display: "flex",
                              alignItems: "center",
                              position: "absolute",
                              top: "0",
                              right: "0",
                              zIndex: "1",
                              color: "Orange",
                            }}
                          >
                            <SentimentSatisfiedAltIcon
                              sx={{ color: "Orange", marginRight: "5px" }}
                            />
                            {item?.status}
                          </span>
                        </div>
                      ) : item?.status === "Paid Leave" ? (
                        <div>
                          <span
                            style={{
                              fontSize: "13px",
                              fontWeight: "500",
                              padding: "2px 5px",
                              margin: "5px",
                              borderRadius: "5px",
                              display: "flex",
                              alignItems: "center",
                              position: "absolute",
                              top: "0",
                              right: "0",
                              zIndex: "1",
                              color: "#1A3D64",
                            }}
                          >
                            <PaidIcon
                              sx={{ color: "#1A3D64", marginRight: "6px" }}
                            />
                            {item?.status}
                          </span>
                        </div>
                      ) : (
                        <span
                          style={{
                            fontSize: "13px",
                            fontWeight: "500",
                            padding: "2px 5px",
                            margin: "5px",
                            borderRadius: "5px",
                            display: "flex",
                            alignItems: "center",
                            position: "absolute",
                            top: "0",
                            right: "0",
                            zIndex: "1",
                            color: "GrayText",
                          }}
                        >
                          {item.status}
                        </span>
                      )}
                    </td>
                  ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default NewAttendance;
